// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1921810632
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Activity } from './models/member/activity';

@Injectable({
  providedIn: 'root',
})
export class ActivitiesApiService {
  constructor(protected http: HttpClient) {}

  getAllActivities(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Activity>> {
    let url = environment.chiliSauceApiRoot + `/api/Activities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Activity>>(url);
  }

  addActivity(newActivity: Activity): Observable<Activity> {
    const url = environment.chiliSauceApiRoot + `/api/Activities`;
    return this.http.post<Activity>(url, newActivity);
  }

  getActivityById(activityGuid: string): Observable<Activity> {
    const url =
      environment.chiliSauceApiRoot + `/api/Activities/${activityGuid}`;
    return this.http.get<Activity>(url);
  }

  updateActivity(activity: Activity, activityGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Activities/${activityGuid}`;
    return this.http.put<any>(url, activity);
  }

  deleteActivity(activityGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Activities/${activityGuid}`;
    return this.http.delete(url);
  }
}
